/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import proptypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Summary } from './Summary';
import { DynamicRecsWrapper } from '../dynamic-recs/DynamicRecsWrapper';
import { dynamicRecsDataModel } from '../dataModel';

const { string: stringType, bool: boolType } = proptypes;

const MoreLikeThisPlpWrapper = (props) => {
  const {
    anchorId,
    storeId,
  } = props;
  return (
    <div className="sui-p-0">
      <Summary
        itemId={anchorId}
        storeId={storeId}
      />
      <DynamicRecsWrapper anchor={anchorId} isMoreLikeThisPlp {...props} />
    </div>
  );
};

MoreLikeThisPlpWrapper.displayName = 'MoreLikeThisPlpWrapper';

MoreLikeThisPlpWrapper.propTypes = {
  anchorId: stringType.isRequired,
  storeId: stringType.isRequired,
};
MoreLikeThisPlpWrapper.dataModel = extend(Summary, dynamicRecsDataModel);

export { MoreLikeThisPlpWrapper };
